var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnSolutionLine4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2137_20258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8984 37.4148C51.3181 16.8022 80.4693 16.8022 87.889 37.4148V37.4148H43.8984V37.4148Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6952 89.0548V89.5548H22.1952V89.0548H21.6952ZM12.8926 89.0548V88.5548H12.3926V89.0548H12.8926ZM12.8926 99.9305H12.3926V100.431H12.8926V99.9305ZM118.894 99.9305V100.431H119.394V99.9305H118.894ZM118.894 89.0548H119.394V88.5548H118.894V89.0548ZM110.091 89.0548H109.591V89.5548H110.091V89.0548ZM22.1952 45.8361C22.1952 41.4614 25.7416 37.915 30.1163 37.915V36.915C25.1893 36.915 21.1952 40.9091 21.1952 45.8361H22.1952ZM22.1952 89.0548V45.8361H21.1952V89.0548H22.1952ZM12.8926 89.5548H21.6952V88.5548H12.8926V89.5548ZM13.3926 99.9305V89.0548H12.3926V99.9305H13.3926ZM118.894 99.4305H12.8926V100.431H118.894V99.4305ZM118.394 89.0548V99.9305H119.394V89.0548H118.394ZM110.091 89.5548H118.894V88.5548H110.091V89.5548ZM109.591 45.8361V89.0548H110.591V45.8361H109.591ZM101.67 37.915C106.045 37.915 109.591 41.4614 109.591 45.8361H110.591C110.591 40.9091 106.597 36.915 101.67 36.915V37.915ZM30.1163 37.915H101.67V36.915H30.1163V37.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1777,
    y: 46.0244,
    width: 5.75,
    height: 5.75,
    rx: 2.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6113,
    y: 46.0244,
    width: 5.75,
    height: 5.75,
    rx: 2.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.0469,
    y: 46.0244,
    width: 5.75,
    height: 5.75,
    rx: 2.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8418 72.8122C37.8418 68.1613 41.612 64.3911 46.2628 64.3911H49.3269C53.9777 64.3911 57.748 68.1613 57.748 72.8122V88.7464H37.8418V72.8122Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6372 89.0548V89.5548H79.1372V89.0548H78.6372ZM70.1504 89.0548V88.5548H69.6504V89.0548H70.1504ZM70.1504 99.9305H69.6504V100.431H70.1504V99.9305ZM118.889 99.9305V100.431H119.389V99.9305H118.889ZM118.889 89.0548H119.389V88.5548H118.889V89.0548ZM110.085 89.0548H109.585V89.5548H110.085V89.0548ZM79.1372 45.8361C79.1372 41.4614 82.6836 37.915 87.0583 37.915V36.915C82.1313 36.915 78.1372 40.9091 78.1372 45.8361H79.1372ZM79.1372 89.0548V45.8361H78.1372V89.0548H79.1372ZM70.1504 89.5548H78.6372V88.5548H70.1504V89.5548ZM70.6504 99.9305V89.0548H69.6504V99.9305H70.6504ZM118.889 99.4305H70.1504V100.431H118.889V99.4305ZM118.389 89.0548V99.9305H119.389V89.0548H118.389ZM110.085 89.5548H118.889V88.5548H110.085V89.5548ZM109.585 45.8361V89.0548H110.585V45.8361H109.585ZM101.664 37.915C106.039 37.915 109.585 41.4614 109.585 45.8361H110.585C110.585 40.9091 106.591 36.915 101.664 36.915V37.915ZM87.0583 37.915H101.664V36.915H87.0583V37.915Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2137_20258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0.552734 0.391113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnSolutionLine4);
export default __webpack_public_path__ + "static/media/nhnSolutionLine4.def55cb60c2e1e5c3443f40e1eaabdc2.svg";
export { ForwardRef as ReactComponent };